export * from './consumidor.component';
export * from './consumidor-adicional/consumidor-adicional.component';
export * from './consumidor-alterar-senha/consumidor-alterar-senha.component';
export * from './consumidor-cadastrar/consumidor-cadastrar.component';
export * from './consumidor-cartao/consumidor-cartao.component';
export * from './consumidor-descadastrar/consumidor-descadastrar.component';
export * from './consumidor-detalhar/consumidor-detalhar.component';
export * from './consumidor-edit/consumidor-edit.component';
export * from './consumidor-instituicao/consumidor-instituicao.component';
export * from './consumidor-list/consumidor-list.component';
export * from './consumidor-login/consumidor-login.component';
export * from './consumidor-msg-senha-alterada/consumidor-msg-senha-alterada.component';
export * from './consumidor-senha-logado/consumidor-senha-logado.component';
export * from './consumidor-detalhe-sorteio/consumidor-detalhe-sorteio.component';
export * from './consumidor-bilhetes/consumidor-bilhetes.component';
export * from './consumidor-detalhe-sorteio/consumidor-visualizar-bilhetes/consumidor-visualizar-bilhetes/consumidor-visualizar-bilhetes.component';
export * from './consumidor-notas/consumidor-notas.component';
export * from './consumidor-premios/consumidor-premios.component';
export * from './consumidor-obrigado/consumidor-obrigado.component';




// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/index.ts